import React, { useEffect, useContext } from 'react';
import { Box, CircularProgress, Divider } from '@mui/material';
import { env } from 'constants';
import Modifier from './Modifier';
import { modifierContext } from '../../ModifierProvider';

function Modifiers({ errorVersion, showModifiersError }) {
  const { visibleModifiers, unSatisfiedModifiers, loading } = useContext(modifierContext);

  // TODO: use event
  useEffect(() => {
    if (unSatisfiedModifiers.length === 0 || (env.IS_CATERING && errorVersion === 1)) {
      return;
    }
    document
      .getElementById(getModifierId(unSatisfiedModifiers[0]))
      ?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
  }, [errorVersion]);

  function getModifierId(modifier) {
    return `app-modifier-${modifier.id}`;
  }

  if (loading) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" py={10}>
        <CircularProgress />
      </Box>
    );
  }

  if (visibleModifiers.length === 0) {
    return null;
  }

  return (
    <>
      {visibleModifiers.map((m, index) => (
        <Box key={index} sx={{ mb: 1 }} id={getModifierId(m)}>
          <Modifier modifier={m} showModifiersError={showModifiersError} />
          {index !== visibleModifiers.length - 1 && <Divider sx={{ mt: 1, mb: 2 }} />}
        </Box>
      ))}
    </>
  );
}

export default Modifiers;
